import type {
  CatchupFormatted,
  CatchupProgramFormatted,
} from '~/shared/interfaces'

import { createEvent, sample } from 'effector'
import { getPriceSettingsExternalPaymentData } from '~/shared/price-settings/helpers'
import { getPaymentTvChannelMediaType, isPaid } from '../../lib'
import * as external from '../model'

export const selectCatchupPaymentEvent = createEvent<{
  catchup: CatchupFormatted
  program: CatchupProgramFormatted
}>()

export const payForCatchup = createEvent<CatchupFormatted>()

sample({
  clock: selectCatchupPaymentEvent,
  source: external.$externalPaymentEnabled,
  filter: (external, { catchup }) => external && isPaid(catchup.channel),
  fn: (_, { catchup, program }) => ({
    id: catchup.channel.id,
    mediaType: catchup.channel.priceSettings
      ? getPaymentTvChannelMediaType(catchup.channel.priceSettings)
      : null,
    params: {
      channelId: catchup.channel.id,
      catchupId: catchup.id,
      programmeId: program.id,
    },
    ...getPriceSettingsExternalPaymentData(
      catchup.channel.priceSettings,
      catchup.channel.externalId
    ),
  }),
  target: external.selectForExternalPayment,
})
